export default "__VITE_ASSET__CcWD1Zhe__"